import { render, staticRenderFns } from "./RulesAndRegulations.vue?vue&type=template&id=f56bd05a&scoped=true"
import script from "./RulesAndRegulations.vue?vue&type=script&lang=js"
export * from "./RulesAndRegulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56bd05a",
  null
  
)

export default component.exports